<template>
  <v-container fluid>
    <v-row>
      <gmap-map style="width: 100%; height: 400px" :zoom="zoom" :center="center" :options="mapOptions">

        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
        </gmap-info-window>

        <gmap-marker v-for="(marker, index) in markers"
          :key="marker.id"
          :position="marker.position"
          :title="marker.title"
          :icon="marker.icon"
          @click="toggleInfoWindow(marker, index)"
        />

        <gmap-circle v-for="(circle, index) in circles"
          :key="circle.id"
          :center="circle.center"
          :radius="circle.radius"
          :options="circleOptions"
        />
      </gmap-map>
    </v-row>
</v-container>
</template>

<script>

export default {
  name: 'events-map',
  components: {
  },
  props: {
    markers: Array,
    circles: Array
  },
  data () {
    return {
      // mile: 1609.344,
      zoom: 5,
      mapOptions: {
        mapTypeControl: false,
        streetViewControl: false
      },
      center: {
        lat: 33.8361,
        lng: -81.1637
      },
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,

      infoOptions: {
        content: '',
        // optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      circleOptions: {
        strokeColor: '#3b5998',
        strokeOpacity: 0.5,
        strokeWeight: 1,
        fillColor: '#3b5998',
        fillOpacity: 0.11
      }
    }
  },
  methods: {
    toggleInfoWindow (marker, idx) {
      this.center = marker.position
      this.infoWindowPos = marker.position
      this.infoOptions.content = marker.infoText

      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        // if different marker set infowindow to open and reset current marker index
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    }
  },
  mounted () {
  }
}
</script>
